module.exports = __webpack_public_path__ + "static/7c-4db8ca44e0a1e8cdff691310efa4e27a.png";